export default __webpack_public_path__ + "static/media/SLIDE_HENRIQUEZ_8.dce72e62.jpg";